export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            关于我们
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-5">
            打造最受信赖的免费视频平台
          </h2>
          <p className="text-base text-foreground-600 leading-relaxed mb-6">
            91免费视频网站自创立以来，始终秉持"高清、免费、流畅"的核心理念，致力于为广大视频爱好者提供一站式的在线观看体验。平台汇聚了涵盖影视、综艺、纪录、短片等丰富类型的优质内容，支持91免费视频网站在线观看与91在线观看视频网站无缝切换，无论您使用电脑还是手机，都能享受高清视频不缓冲的畅快体验。我们每日持续更新资源库，确保每一位访客都能在这里找到心仪的精彩内容，真正实现免费视频网站在线观看零门槛。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 pt-2">
            <div className="text-center">
              <p className="text-3xl font-bold text-primary-500">3+</p>
              <p className="text-sm text-foreground-500 mt-1">年稳定运营</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-accent-500">5000+</p>
              <p className="text-sm text-foreground-500 mt-1">精选视频资源</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-primary-500">100万+</p>
              <p className="text-sm text-foreground-500 mt-1">累计访客</p>
            </div>
            <div className="text-center">
              <p className="text-3xl font-bold text-accent-500">15+</p>
              <p className="text-sm text-foreground-500 mt-1">内容分类</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}